import * as React from 'react'
import { isLastItem } from '@mprolab/sdk'
import { Grid } from '@mui/material'
import styled from 'styled-components'
import { height, HeightProps } from 'styled-system'
import { MediaQuery } from '../../../theme/base'
import { EmptyTableRow } from '../Table.types'
import { StyledRowWrapper } from '.'
import { Flex } from '../../Flex'

const LoadingRowsWrapper = styled(Flex)`
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: max-content;
  width: 100%;
`

const StaticDataBox = styled.div`
  height: 27px;
  width: 100%;
  background: ${({ theme }) => theme.colors.gray10};
  opacity: 0.2;
  border-radius: 8px;
  order: 0;
  flex-grow: 0;
`

const ChildrenWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
`

const LoadingDataBox = styled.div<HeightProps>`
  @keyframes loading {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  min-height: 20px;
  height: 100%;
  color: transparent;
  background: ${({ theme }) =>
    `linear-gradient(100deg, ${theme.colors.gray7} 30%, ${theme.colors.gray8} 50%, ${theme.colors.gray7} 70%)`};
  animation: loading 2s ease-in-out infinite;
  background-size: 500%;
  margin: 0px 4px;
  border-radius: 15px;
  ${height}
`

interface LoadingRowsProps {
  emptyRowsArray: EmptyTableRow[]
  fullViewMediaquery: MediaQuery
  fullViewCustomWidth: number
  children?: React.ReactNode
  isEmpty?: boolean
}

const LoadingRows: React.FunctionComponent<LoadingRowsProps> = ({
  emptyRowsArray,
  fullViewMediaquery,
  fullViewCustomWidth,
  children,
  isEmpty = false
}) => {
  return (
    <LoadingRowsWrapper>
      {emptyRowsArray.map((emptyRow, rowIndex) => {
        return (
          <StyledRowWrapper
            id={`${rowIndex}_tableRow`}
            key={rowIndex}
            isEmpty={isEmpty}
            isLastItem={isLastItem(emptyRowsArray, rowIndex)}
            fullViewMediaquery={fullViewMediaquery}
            fullViewCustomWidth={fullViewCustomWidth}
          >
            <Grid container style={{ width: '100%' }}>
              {(isEmpty ? [{ gridColumns: 12 }] : emptyRow.cells).map((cell, cellIndex) => {
                return (
                  <Grid key={cellIndex} id={`${cellIndex}_tableCell`} item xs={cell.gridColumns}>
                    {isEmpty ? <StaticDataBox /> : <LoadingDataBox />}
                  </Grid>
                )
              })}
            </Grid>
          </StyledRowWrapper>
        )
      })}
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </LoadingRowsWrapper>
  )
}

export default LoadingRows
